export const TWO_WAY_AUDIO_ESCALATION_ONLY_FEATURE_NAME = 'TwoWayAudioEscalationOnly'

export const NO_ODMON_CAMERAS_ENROLLED_NOTE = 'No cameras currently enrolled in Active Guard Outdoor Protection'

export const FEATURE_NAME_MAP: Record<string, string> = {
  VisualVerification: 'Video Verification',
  LiveGuardProtection: 'Intruder Intervention',
  BetaProgramsInterestList: 'Interested In Beta Programs',
  InternalReviewRecordingAccess: 'QA Access (Legacy - Intruder Intervention Only)',
  OperationalQualityAssuranceReviewEligible: 'QA Access (All Monitored Video)',
  MachineLearningTrainingEligible: 'ML Training Access',
  SemanticSearch: 'Video Search',
  [TWO_WAY_AUDIO_ESCALATION_ONLY_FEATURE_NAME]: 'Two Way Audio - Escalation Only'
}
